import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

let timer = null;

export default function BasicTextFields(props) {
    const min = props.values.at(-1);
    const max = props.values[0];
    const [value, setValue] = React.useState([min, max]);

    const handleChangeFrom = (event) => {
        setValue([Number(event.target.value), value[1]]);
        props.filter([Number(event.target.value), value[1]]);
    };
    const handleChangeTo = (event) => {
        setValue([value[0], Number(event.target.value)]);
        props.filter([value[0], Number(event.target.value)]);
    };

    return (
        <Box
            component="form"
            sx={{
                '& > :not(style)': { m: 1, width: '124px' },
            }}
            noValidate
            autoComplete="off"
        >
            <TextField id="outlined-basic" label={`Min (${min})`} variant="outlined" size="small" 
                onChange={handleChangeFrom}
            />
            <TextField id="outlined-basic" label={`Max (${max})`} variant="outlined" size="small" 
                onChange={handleChangeTo}
            />
        </Box>
    );
}